import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import routes from "~/config/routes";
import { useAuth } from "~/state/auth/AuthContext";
import { DialogProvider } from "~/utils/DialogProvider";
import PrivateRoute from "./PrivateRoute";
import PublicRoute from "./PublicRoute";
import ScheduleRoute from "./ScheduleRoute";

const Routers = () => {
	
	return (
		<Switch>
			{routes.map((route, index) => {
				const Component = route.view;
				if (route.path === "/robots.txt" || route.path === "/sitemap.xml") {
					return null;
				}

				const routeProps = {
					key: index,
					path: route.path,
					exact: route.exact,
					children: <DialogProvider Component={Component} />,
				};

				switch (route.access) {
					case "private":
						return <PrivateRoute {...routeProps} />;
					case "public":
						return <PublicRoute {...routeProps} />;
					case "schedule":
						return <ScheduleRoute {...routeProps} requireLocationState={true} />;
					default:
						return <PublicRoute {...routeProps} />;
				}
			})}
			<Redirect to="/not-found" />
		</Switch>
	);
};

export default Routers;

